import { render, staticRenderFns } from "./UseCaseRequestsAdmin.vue?vue&type=template&id=075c2bbe"
import script from "./UseCaseRequestsAdmin.vue?vue&type=script&lang=js"
export * from "./UseCaseRequestsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports